import {
  Users,
  Mail,
  Grid,
  Settings,
  HelpCircle,
  Square,
  Home,
  User,
  ShoppingBag,
  Edit,
  BookOpen,
  Book,
  Clipboard,
  Truck,
  Box
} from "react-feather";

export const showButtonforPath = [
  {
    url: "/booking/booking-history",
    value: "booking-info",
  },
  {
    url: "/trips/trip-history",
    value: "trip-info",
  },
  {
    url: "/customers",
    value: "customer-profile",
  },
  {
    url: "/driver/driver-listing",
    value: "driver-info",
  },
  {
    url: "/vendor/vendor-list",
    value: "vendor-profile"
  },
];

export const Admin = "ROLE_ADMIN";
export const Dispatch = "ROLE_DISPATCHER";
export const Capture = "ROLE_CALLTAKER";
export const ShiftInCharge = "ROLE_SHIFTINCHARGE";
export const Accountant = "ROLE_ACCOUNTANT";
export const AirportAgent = "ROLE_AIRPORTAGENT";
export const OnboardingAgent = "ROLE_ONBOARDING_AGENT";
export const VendorAgent = "ROLE_AGGREGATOR";

export const HomePageMapping = {
  [Capture]: "dashboard/capture-dashboard",
  [Dispatch]: "dashboard/dispatch-dashboard",
  [Admin]: "dashboard/dispatch-dashboard",
  [ShiftInCharge]: "dashboard/dispatch-dashboard",
  [Accountant]: "booking/booking-history",
  [AirportAgent]: "driver/driver-listing",
  [OnboardingAgent]: "booking/booking-history",
  [VendorAgent]: `${localStorage.getItem("Name")}`,
};

export const Mapping = {
  capture_dashboard: {
    path: `${process.env.PUBLIC_URL}/dashboard/capture-dashboard`,
    icon: <Home />,
  },
  dispatch_dashboard: {
    path: `${process.env.PUBLIC_URL}/dashboard/dispatch-dashboard`,
    icon: <Home />,
  },
  booking: {
    icon: <Grid />,
    path: `${process.env.PUBLIC_URL}/booking/booking-history`,
  },
  booking_history: {
    path: `${process.env.PUBLIC_URL}/booking/booking-history`,
    parent: "booking",
  },
  vendor_booking_history: {
    path: `${process.env.PUBLIC_URL}/vendor/booking-history`,
    parent: "booking",
  },
  vendor_trip_history: {
    path: `${process.env.PUBLIC_URL}/vendor/trip-history`,
    parent: "booking",
  },
  vendor_car_current_status: {
    path: `${process.env.PUBLIC_URL}/vendor/car-current-status`,
    parent: "booking",
  },
  trip_history: {
    path: `${process.env.PUBLIC_URL}/trips/trip-history`,
    parent: "booking",
  },
  driver_management: {
    path: `${process.env.PUBLIC_URL}/driver/driver-listing`,
    icon: <Square />,
  },
  driver: {
    path: `${process.env.PUBLIC_URL}/driver/driver-listing`,
    parent: "driver_management"
  },
  driver_payout: {
    path: `${process.env.PUBLIC_URL}/driver/driver-payout`,
    parent: "driver_management"
  },
  driver_Deduction:{
    path:`${process.env.PUBLIC_URL}/user/driver/deduction`,
    parent:"driver_management"
  },
  driver_recharge: {
    path: `${process.env.PUBLIC_URL}/driver/driver-recharge`,
    parent: "driver_management"
  },
  driver_type: {
    path: `${process.env.PUBLIC_URL}/driver/driverType`,
    parent: "driver_management"
  },
  driver_deduction_approval: {
    path: `${process.env.PUBLIC_URL}/driver/deduction-approval`,
    parent: "driver_management"
  },
  inventory_management: {
    path: `${process.env.PUBLIC_URL}/inventory/cab-listing`,
    icon: <Box />,
  },
  cab_inventory_listing: {
    path: `${process.env.PUBLIC_URL}/inventory/cab-listing`,
    parent: "inventory_management"
  },
  blocked_cab_listing: {
    path: `${process.env.PUBLIC_URL}/inventory/blocked-cab-listing`,
    parent: "inventory_management"
  },
  cab_management: {
    path: `${process.env.PUBLIC_URL}/driver/cab/cab-inventory-listing`,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.5 7c.276 0 .5.224.5.5v.511c0 .793-.926.989-1.616.989l-1.086-2h2.202zm-1.441 3.506c.639 1.186.946 2.252.946 3.666 0 1.37-.397 2.533-1.005 3.981v1.847c0 .552-.448 1-1 1h-1.5c-.552 0-1-.448-1-1v-1h-13v1c0 .552-.448 1-1 1h-1.5c-.552 0-1-.448-1-1v-1.847c-.608-1.448-1.005-2.611-1.005-3.981 0-1.414.307-2.48.946-3.666.829-1.537 1.851-3.453 2.93-5.252.828-1.382 1.262-1.707 2.278-1.889 1.532-.275 2.918-.365 4.851-.365s3.319.09 4.851.365c1.016.182 1.45.507 2.278 1.889 1.079 1.799 2.101 3.715 2.93 5.252zm-16.059 2.994c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5.672 1.5 1.5 1.5 1.5-.672 1.5-1.5zm10 1c0-.276-.224-.5-.5-.5h-7c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5zm2.941-5.527s-.74-1.826-1.631-3.142c-.202-.298-.515-.502-.869-.566-1.511-.272-2.835-.359-4.441-.359s-2.93.087-4.441.359c-.354.063-.667.267-.869.566-.891 1.315-1.631 3.142-1.631 3.142 1.64.313 4.309.497 6.941.497s5.301-.184 6.941-.497zm2.059 4.527c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5.672 1.5 1.5 1.5 1.5-.672 1.5-1.5zm-18.298-6.5h-2.202c-.276 0-.5.224-.5.5v.511c0 .793.926.989 1.616.989l1.086-2z"/></svg>,
  },
  cab_listing: {
    path: `${process.env.PUBLIC_URL}/driver/cab/cab-listing`,
    parent: "cab_management",
  },
  cab_tracking: {
    path: `${process.env.PUBLIC_URL}/driver/cab/cab-tracking`,
    parent: "cab_management",
  },
  cab_Type:{
    path: `${process.env.PUBLIC_URL}/user/car/type`,
    parent: "cab_management",
  },
  support: {
    icon: <Mail />,
    path: `${process.env.PUBLIC_URL}/support/ticket-history`,
  },
  reports: {
    icon: <Clipboard />,
    path: `${process.env.PUBLIC_URL}/reports`,
  },
  ticket_history: {
    path: `${process.env.PUBLIC_URL}/support/ticket-history`,
    parent: "support",
  },
  customers: {
    icon: <Users />,
    path: `${process.env.PUBLIC_URL}/customers`,
  },
  customer_listing: {
    path: `${process.env.PUBLIC_URL}/customers`,
    parent: "customers",
  },
  user: {
    path: `${process.env.PUBLIC_URL}/user/otp-listing`,
    icon: <User />,
  },
  employee_list: {
    path: `${process.env.PUBLIC_URL}/user/employee-listing`,
    parent: "user",
  },
  otp_list: {
    path: `${process.env.PUBLIC_URL}/user/otp-listing`,
    parent: "user",
  },
  External_user: {
    path: `${process.env.PUBLIC_URL}/user/external_user`,
    parent: "user",
  },
  vendor: {
    path: `${process.env.PUBLIC_URL}/vendor/vendor-list`,
    icon: <User />,
  },
  vendor_listing: {
    path: `${process.env.PUBLIC_URL}/vendor/vendor-list`,
    icon: <User />,
    parent: "vendor",
  },
  fleet: {
    path: `${process.env.PUBLIC_URL}/fleet`,
    icon: <Grid />,
  },
  invoice: {
    path: `${process.env.PUBLIC_URL}/bookings/invoice-correction`,
    icon: <Edit />,
  },
  invoice_correction: {
    path: `${process.env.PUBLIC_URL}/bookings/invoice-correction`,
    parent: "invoice_management",
  },
  invoice_list: {
    path: `${process.env.PUBLIC_URL}/bookings/invoice-list`,
    parent: "invoice_management",
  },
  settings: {
    icon: <Settings />,
  },
  user_profile: {
    icon: <User />,
  },
  tariff_master: {
    icon: <Book />,
  },
  corporate_clients: {
    path: `${process.env.PUBLIC_URL}/tariff_master/corporate-clients`,
    parent: "tariff_master",
  },
  rates: {
    path: `${process.env.PUBLIC_URL}/tariff_master/rates`,
    parent: "tariff_master",
  },
  packages: {
    path: `${process.env.PUBLIC_URL}/configurations/packages`,
    parent: "settings",
  },
  package_rates: {
    path: `${process.env.PUBLIC_URL}/tariff_master/package-rates`,
    parent: "tariff_master",
  },
  View_Tariff: {
    path: `${process.env.PUBLIC_URL}/tariff_master/view`,
    parent: "tariff_master",
  },

  Create_Tariff: {
    path: `${process.env.PUBLIC_URL}/tariff_master/create`,
    parent: "tariff_master",
  },

  coupons: {
    path: `${process.env.PUBLIC_URL}/configurations/coupons`,
    parent: "settings",
  },
  zone: {
    path: `${process.env.PUBLIC_URL}/configurations/zone`,
    parent: "settings",
  },
  service_city: {
    path: `${process.env.PUBLIC_URL}/configurations/service-city`,
    parent: "settings",
  },
  offer: {
    path: `${process.env.PUBLIC_URL}/configurations/offer`,
    parent: "settings",
  },
  change_password: {
    path: `${process.env.PUBLIC_URL}/profile/change-password`,
    parent: "user_profile",
  },
  inventory_control: {
    path: `${process.env.PUBLIC_URL}/tariff_master/inventory-control`,
    parent: "tariff_master",
  },

  logout: {
    path: `${process.env.PUBLIC_URL}/login`,
    parent: "settings",
  },
  help: {
    icon: <HelpCircle />,
    path: `${process.env.PUBLIC_URL}/help`,
  },
  // create_Tariff:{
  //   icon:<Book />,
  //   path:`${process.env.PUBLIC_URL}/user/test`
  // }
};

export const RoleMapping = {
  [Admin]: [
    {
      name: "dispatch_dashboard",
      label: "Dashboard",
    },
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "booking_history",
          label: "Accepted Booking",
        },
        {
          name: "trip_history",
          label: "Trip History",
        },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "employee_list",
          label: "Employee Management",
        },
        {
          name: "otp_list",
          label: "OTP Management",
        },
        {
          name: "External_user",
          label: "External User",
        },
      ],
    },
    // {
    //   name: "coupon",
    //   label: "Coupon Management",
    //   children: [
    //     {
    //       name: "coupon_list",
    //       label: "All Coupon",
    //     },
    //   ],
    // },

    {
      name: "driver_management",
      label: "Driver Management",
      children: [
        {
          name: "driver",
          label: "Drivers",
        },

        {
          name: "driver_type",
          label: "Driver Scheme",
        },

        // {
        //   name: "driver_Deduction",
        //   label: "Driver Configurations",
        // },
        {
          name: "driver_payout",
          label: "Driver Payout",
        },
        {
          name: "driver_deduction_approval",
          label: "Driver Deduction Approval",
        }
        
        // {
        //   name: "driver_recharge",
        //   label: "Driver Recharge",
        // },
      ],
    },
    {
      name: "inventory_management",
      label: "Inventory Management",
      children: [
        {
          name: "cab_inventory_listing",
          label: "Cabs",
        },
        {
          name: "blocked_cab_listing",
          label: "Blocked Cabs",
        },
      ],
    },
    {
      name: "customers",
      label: "Customer Management",
    },
    {
      name: "vendor",
      label: "Vendor Management",
      children: [
        {
          name: "vendor_listing",
          label: "Vendor Listing",
        },
      ],
    },
    {
      name: "cab_management",
      label: "Cab Management",
      children: [
        {
          name: "cab_listing",
          label: "Cab Status",
        },
        {
          name: "cab_tracking",
          label: "Cab Tracking",
        },
        {
          name: "cab_Type",
          label: "Cab Type",
        },

      ],
    },
    // {
    //   name: "fleet",
    //   label: "Fleet Management",
    // },
    // {
    //   name: "support",
    //   label: "Support",
    // },
    {
      name: "reports",
      label: "Reports",
    },
    {
      name: "invoice",
      label: "Invoice Management",
      children: [
        {
          name: "invoice_correction",
          label: "Invoice Correction",
        },
        {
          name: "invoice_list",
          label: "Invoice List",
        },
      ],
    },
    {
      name: "tariff_master",
      label: "Tariff Management",
      children: [
        // {
        //   name: "corporate_clients",
        //   label: "Corporate Clients",
        // },
        // {
        //   name: "rates",
        //   label: "Rates",
        // },
      
        // {
        //   name: "package_rates",
        //   label: "Package Rates"
        // },
        // {
        //   name:"Create_Tariff",
        //   label:"Create Tariff"
        // },
        {
          name: "View_Tariff",
          label: "Tariff"
        },
        {
          name: "inventory_control",
          label: "Inventory Control",
        },
      ],
    },
    // {
    //   name: "create_Tariff",
    //   label: "Create Tariff",
    // },
    {
      name: "settings",
      label: "Configuration",
      children: [
        {
          name: "coupons",
          label: "Coupons",
        },
        {
          name: "zone",
          label: "Zone",
        },
        {
          name: "service_city",
          label: "Service City",
        },
        {
          name: "offer",
          label: "Offer",
        },
        // {
        //   name: "packages",
        //   label: "Packages",
        // },
      ],
    },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        }
      ],
    },
  ],
  [Capture]: [
    {
      name: "capture_dashboard",
      label: "Dashboard",
    },
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "booking_history",
          label: "Accepted Booking",
        },
        {
          name: "trip_history",
          label: "Trip History",
        },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "otp_list",
          label: "OTP Management",
        },
      ],
    },
    {
      name: "customers",
      label: "Customer Management",
    },
    // {
    //   name: "help",
    //   label: "Help",
    // },
    // {
    //   name: "support",
    //   label: "Support",
    // },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        }
      ],
    },
  ],
  [Dispatch]: [
    {
      name: "dispatch_dashboard",
      label: "Dashboard",
    },
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "booking_history",
          label: "Accepted Booking",
        },
        {
          name: "trip_history",
          label: "Trip History",
        },
      ],
    },
    
    {
      name: "driver_management",
      label: "Driver Management",
      children: [
        {
          name: "driver",
          label: "Drivers",
        },
        // {
        //   name: "driver_recharge",
        //   label: "Driver Recharge",
        // },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "otp_list",
          label: "OTP Management",
        },
      ],
    },
    {
      name: "inventory_management",
      label: "Inventory Management",
      children: [
        {
          name: "cab_inventory_listing",
          label: "Cabs",
        },
        {
          name: "blocked_cab_listing",
          label: "Blocked Cabs",
        },
      ],
    },
    {
      name: "cab_management",
      label: "Cab Management",
      children: [
        {
          name: "cab_listing",
          label: "Cab Status",
        },
        {
          name: "cab_tracking",
          label: "Cab Tracking",
        },
      ],
    },
    {
      name: "customers",
      label: "Customer Management",
    },
    // {
    //   name: "vendor",
    //   label: "Vendor Management",
    //   children: [
    //     {
    //       name: "vendor_listing",
    //       label: "Vendor Listing",
    //     },
    //   ],
    // },
    // {
    //   name: "support",
    //   label: "Support",
    // },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        }
      ],
    },
  ],
  [ShiftInCharge]: [
    {
      name: "dispatch_dashboard",
      label: "Dashboard",
    },
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "booking_history",
          label: "Accepted Booking",
        },
        {
          name: "trip_history",
          label: "Trip History",
        },
      ],
    },

    {
      name: "driver_management",
      label: "Driver Management",
      children: [
        {
          name: "driver",
          label: "Drivers",
        },
        // {
        //   name: "driver_recharge",
        //   label: "Driver Recharge",
        // },
      ],
    },
    {
      name: "cab_management",
      label: "Cab Management",
      children: [
        {
          name: "cab_listing",
          label: "Cab Status",
        },
        {
          name: "cab_tracking",
          label: "Cab Tracking",
        },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "otp_list",
          label: "OTP Management",
        },
      ],
    },
    {
      name: "inventory_management",
      label: "Inventory Management",
      children: [
        {
          name: "cab_inventory_listing",
          label: "Cabs",
        },
        {
          name: "blocked_cab_listing",
          label: "Blocked Cabs",
        },
      ],
    },
    {
      name: "vendor",
      label: "Vendor Management",
      children: [
        {
          name: "vendor_listing",
          label: "Vendor Listing",
        },
      ],
    },
    {
      name: "invoice",
      label: "Invoice Management",
      children: [
        {
          name: "invoice_correction",
          label: "Invoice Correction",
        },
        {
          name: "invoice_list",
          label: "Invoice List",
        },
      ],
    },
    {
      name: "customers",
      label: "Customer Management",
    },
    {
      name: "reports",
      label: "Reports",
    },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        }
      ],
    },
  ],
  [Accountant]: [
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "booking_history",
          label: "Accepted Booking",
        },
        {
          name: "trip_history",
          label: "Trip History",
        },
      ],
    },
    {
      name: "driver_management",
      label: "Driver Management",
      children: [
        {
          name: "driver",
          label: "Drivers",
        },
        // {
        //   name: "driver_recharge",
        //   label: "Driver Recharge",
        // },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "otp_list",
          label: "OTP Management",
        },
      ],
    },
    {
      name: "cab_management",
      label: "Cab Management",
      children: [
        {
          name: "cab_listing",
          label: "Cab Status",
        },
        {
          name: "cab_tracking",
          label: "Cab Tracking",
        },
      ],
    },
    {
      name: "inventory_management",
      label: "Inventory Management",
      children: [
        {
          name: "cab_inventory_listing",
          label: "Cabs",
        },
        {
          name: "blocked_cab_listing",
          label: "Blocked Cabs",
        },
      ],
    },
    {
      name: "reports",
      label: "Reports",
    },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        }
      ],
    },
  ],
  [AirportAgent]: [
    {
      name: "driver_management",
      label: "Driver Management",
      children: [
        {
          name: "driver",
          label: "Drivers",
        },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "otp_list",
          label: "OTP Management",
        },
      ],
    },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        }
      ],
    },
  ],
  [OnboardingAgent]: [
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "booking_history",
          label: "Accepted Booking",
        },
        {
          name: "trip_history",
          label: "Trip History",
        },
      ],
    },
    {
      name: "driver_management",
      label: "Driver Management",
      children: [
        {
          name: "driver",
          label: "Drivers",
        },
        // {
        //   name: "driver_recharge",
        //   label: "Driver Recharge",
        // },
      ],
    },
    {
      name: "user",
      label: "User Management",
      children: [
        {
          name: "otp_list",
          label: "OTP Management",
        },
      ],
    },
    {
      name: "cab_management",
      label: "Cab Management",
      children: [
        {
          name: "cab_listing",
          label: "Cab Status",
        },
        {
          name: "cab_tracking",
          label: "Cab Tracking",
        },
      ],
    },
    {
      name: "vendor",
      label: "Vendor Management",
      children: [
        {
          name: "vendor_listing",
          label: "Vendor Listing",
        },
      ],
    },
    {
      name: "inventory_management",
      label: "Inventory Management",
      children: [
        {
          name: "cab_inventory_listing",
          label: "Cabs",
        },
        {
          name: "blocked_cab_listing",
          label: "Blocked Cabs",
        },
      ],
    },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        },
      ],
    },
  ],
  [VendorAgent]: [
    {
      name: "booking",
      label: "Trip Management",
      children: [
        {
          name: "vendor_booking_history",
          label: "Accepted Booking",
        },
        {
          name: "vendor_trip_history",
          label: "Trip History",
        },
        {
          name: "vendor_car_current_status",
          label: "Car Current Status",
        },
      ],
    },
    {
      name: "user_profile",
      label: "User Profile",
      children: [
        {
          name: "change_password",
          label: "Change Password",
        },
      ],
    },
  ],
};
